/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_OutcomesInputs */

const en_footer_risks_outcomes = /** @type {(inputs: Footer_Risks_OutcomesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Outcomes`)
};

/**
* | output |
* | --- |
* | "AI Outcomes" |
*
* @param {Footer_Risks_OutcomesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_outcomes = /** @type {((inputs?: Footer_Risks_OutcomesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_OutcomesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_outcomes(inputs)
});